import { c as _c } from "react/compiler-runtime";
import { useSuspenseQuery } from '@tanstack/react-query';
import { UnauthQueryOptions } from '@/api';
import { isSecondDecemberEvent } from '../../_utils/isSecondDecemberEvent';
export const useRankingList = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      ...UnauthQueryOptions["get:/wello/v2/allows/home-donation-event-history/invitee-donation/top"]({
        query: {
          eventCode: isSecondDecemberEvent() ? "INVITER_ON_DONATION_2025_12_2ND" : "INVITER_ON_DONATION_2025_12_1ND",
          size: 10
        }
      }),
      select: _temp
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return useSuspenseQuery(t0);
};
function _temp(t0) {
  const {
    context
  } = t0;
  return context?.contents ?? [];
}